module.exports = __webpack_public_path__ + "static/media/ecoco_5.43ebd80a.webp";